let state = {
    shuerteGame: {
        type: '1', // type: 1—舒尔特方格,2— 你看到了几块小熊饼干, 3— 小海马, 4— 线索排序, 5— 看图找规律
        total_time: '', // //总花费时长
        answer: '0', // 1: 正确；-1: 错误 ;1,-1,1,-1,1,-1; 0 未作答
        is_timeout: false // //是否超时, true: 超时
    },
    attentionGame: {
        type: '2', // type: 1—舒尔特方格,2— 你看到了几块小熊饼干, 3— 小海马, 4— 线索排序, 5— 看图找规律
        total_time: '', // //总花费时长
        answer: '0, 0, 0, 0, 0, 0', // 1: 正确；-1: 错误 ;1,-1,1,-1,1,-1; 0 未作答
        is_timeout: false // //是否超时, true: 超时
    },
    findSheepGame: {
        type: '3', // type: 1—舒尔特方格,2— 你看到了几块小熊饼干, 3— 小海马, 4— 线索排序, 5— 看图找规律
        total_time: '', // //总花费时长
        answer: '0, 0, 0, 0, 0', // 1: 正确；-1: 错误 ;1,-1,1,-1,1,-1; 0 未作答
        is_timeout: false // //是否超时, true: 超时
    },
    rankGame: {
        type: '4', // type: 1—舒尔特方格,2— 你看到了几块小熊饼干, 3— 小海马, 4— 线索排序, 5— 看图找规律
        total_time: '', // //总花费时长
        answer: '0', // 1: 正确；-1: 错误 ;1,-1,1,-1,1,-1; 0 未作答
        is_timeout: false // //是否超时, true: 超时
    },
    regulaGame: {
        type: '5', // type: 1—舒尔特方格,2— 你看到了几块小熊饼干, 3— 小海马, 4— 线索排序, 5— 看图找规律
        total_time: '', // //总花费时长
        answer: '0, 0, 0', // 1: 正确；-1: 错误 ;1,-1,1,-1,1,-1; 0 未作答
        is_timeout: false // //是否超时, true: 超时
    }
};
export default state;


// WEBPACK FOOTER //
// ./src/vuex/modules/sevenAbilityGames/state.js